// Lightweight facade that keeps the Firebase SDK out of the startup bundle.
let firebaseModule = null;
let firebasePromise = null;

const loadFirebase = () => {
  if (!firebasePromise) {
    firebasePromise = import("./firebase").then((module) => {
      firebaseModule = module;
      return module;
    }).catch((error) => {
      firebasePromise = null;
      throw error;
    });
  }
  return firebasePromise;
};

export const canUseNotifications = () =>
  typeof window !== "undefined" && "Notification" in window && "serviceWorker" in navigator;


export const initNotifications = () => loadFirebase().then((module) => module.initNotifications());

export const registerNotificationWorker = () => {
  if (!canUseNotifications()) return Promise.resolve(null);
  return loadFirebase().then((module) => module.registerNotificationWorker());
};

export const setupMessageListener = (callback) =>
  loadFirebase().then((module) => module.setupMessageListener(callback));

export const requestNotificationPermission = async () => {
  if (firebaseModule) return firebaseModule.requestNotificationPermission();
  if (!canUseNotifications()) throw new Error("Browser push is not supported here. Your notification bell still works.");
  // Ask before downloading the SDK so the prompt stays inside the click's user activation.
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Browser notifications are not enabled. You can change permission in browser settings; the bell still works.");
  const module = await loadFirebase();
  return module.requestNotificationPermission();
};

export const unregisterFCMToken = () => {
  if (firebaseModule) return firebaseModule.unregisterFCMToken();
  // Capture the session synchronously; callers may clear auth before the SDK chunk arrives.
  const snapshot = {
    auth: localStorage.getItem("token"),
    previousToken: localStorage.getItem("fcm_token_sent"),
  };
  return loadFirebase()
    .then((module) => module.unregisterFCMToken(snapshot))
    .catch(() => {
      ["fcm_token_sent", "fcm_user_id", "fcm_prompted_at"].forEach((key) => localStorage.removeItem(key));
    });
};
